/* src/services/CustomerService.js */
import apiClient from './api' // Usa il tuo client configurato

export const CustomerService = {

  // Converte i nomi dei campi da Django (snake_case) a Vue (camelCase)
  mapFromApi(data) {
    return {
      id: data.id,
      firstName: data.first_name || '',
      lastName: data.last_name || '',
      email: data.email || '',
      phone: data.phone || '',
      whatsapp: data.whatsapp || '',
      telegram: data.telegram || '',
      isActive: data.is_active ?? true,
      hasWallet: data.has_wallet ?? false
    }
  },

  // Converte i nomi dei campi da Vue a Django per il salvataggio
  mapToApi(customer) {
    return {
      first_name: customer.firstName,
      last_name: customer.lastName,
      email: customer.email,
      phone: customer.phone,
      whatsapp: customer.whatsapp,
      telegram: customer.telegram,
      is_active: customer.isActive
    }
  },

  async getAll() {
    try {
      // Usiamo il path relativo perché apiClient ha già la baseURL
      const response = await apiClient.get('booking/customers/')
      
      if (!Array.isArray(response.data)) {
        console.error("Il server non ha restituito un array:", response.data)
        return []
      }
      
      return response.data.map(item => this.mapFromApi(item))
    } catch (error) {
      console.error("Errore nel recupero clienti:", error)
      throw error
    }
  },

  async create(customer) {
    const payload = this.mapToApi(customer)
    const response = await apiClient.post('booking/customers/', payload)
    return this.mapFromApi(response.data)
  },

  async update(id, customer) {
    const payload = this.mapToApi(customer)
    const response = await apiClient.put(`booking/customers/${id}/`, payload)
    return this.mapFromApi(response.data)
  },

  async delete(id) {
    return await apiClient.delete(`booking/customers/${id}/`)
  }
}